import { request, Paginated } from "utils/api";
import { ReducedUserProfileWithEmail } from "api/user";
import { Club } from "api/clubs";

// report from GET /owner/reports
export interface AccountingReport {
    intervalStartDate: string,
    intervalEndDate?: string,
    resourceUrl?: string,
    totalRevenueCents: number,
    reportType?: string,
    reportingInterval?: string;
    expenseCompanyClub?: Club;
    companyInvoice?: {
        invoicePdfUrl: string;
        totalAmountCents: number;
        invoiceNumber: string;
        invoiceCreatedAt: Date;
    };
    id?: string;
}

// invoice from GET /owner/reports/invoices
export interface Invoice {
    booking: {
        startDate: string,
    },
    invoices: {
        pdfUrl: string,
    }[],
    payingPriceCents: number,
    user: ReducedUserProfileWithEmail,
}

// fetch reports (GET /owner/reports)
export const getReports = (data: {
    clubId?: string,
    limit?: number,
    offset?: number,
    query?: string,
    sortKey?: "reportType" | "intervalStartDate",
    sortOrder?: "ASC" | "DESC",
}) => request<Paginated<AccountingReport>>({
    data,
    endpoint: "/owner/reports",
    method: "get",
});

// fetch booking invoices (GET /owner/reports/invoices)
export const getInvoices = (data: {
    clubId?: string,
    dateInInterval?: string,
    limit?: number,
    offset?: number,
    query?: string,
    reportingInterval?: "month",
    sortKey?: "clubName" | "startDate",
    sortOrder?: "ASC" | "DESC",
}) => request<Paginated<Invoice>>({
    data,
    endpoint: "/owner/reports/invoices",
    method: "get",
});

// export booking invoices (GET /owner/reports/invoices/export)
export const exportInvoices = (data: {
    clubId?: string,
    dateInInterval?: string,
    query?: string,
    reportingInterval?: "month",
    sortKey?: "clubName" | "startDate",
    sortOrder?: "ASC" | "DESC",
}) => request<{ email: string }>({
    data,
    endpoint: "/owner/reports/invoices/export",
    method: "get",
});

// Returning an up-to-date company invoice PDF URL
export const companyInvoicePDF = (data: {
    clubId?: string,
    reportId?: string,
}) => request<{ invoicePdfUrl: string }>({
    data,
    endpoint: "/owner/reports/company-invoice-pdf",
    method: "get",
});
